// extracted by mini-css-extract-plugin
module.exports = {"new_main_page_chart_modal_wrapper":"ChartModal_new_main_page_chart_modal_wrapper__1r7WL"};